export { DetailCard } from './detailCard';
